import { graphql, useFragment } from "react-relay";
import {
  WorkspacePhaseProgressFragment$key,
  WorkspaceRunnerPhase,
} from "./__generated__/WorkspacePhaseProgressFragment.graphql";
import { Progress, ProgressKind } from "@/kit/ui/progress";
import { defineMessages, FormattedMessage } from "react-intl";

const Fragment = graphql`
  fragment WorkspacePhaseProgressFragment on WorkspaceRunner {
    phase
  }
`;

export interface WorkspacePhaseProgressProps {
  kind?: ProgressKind | undefined;
  workspace: WorkspacePhaseProgressFragment$key;
  shift?: number | undefined;
  scale?: number | undefined;
}

export default function WorkspacePhaseProgress({
  kind,
  workspace: workspaceRef,
  shift = 0,
  scale = 1,
}: WorkspacePhaseProgressProps) {
  const workspace = useFragment(Fragment, workspaceRef);
  const progress = Math.round(phases[workspace.phase] * scale + shift);
  const label = phaseLabels[workspace.phase];

  return (
    <Progress kind={kind} value={progress}>
      <FormattedMessage {...label} />
    </Progress>
  );
}

const phases: Readonly<Record<WorkspaceRunnerPhase, number>> = Object.freeze({
  PENDING: 0,
  BINDING_VOLUME: 20,
  PREPARING_WORKSPACE: 40,
  SCHEDULING_POD: 60,
  STARTING_POD: 80,
  READY: 100,
});

const phaseLabels = defineMessages<WorkspaceRunnerPhase>({
  PENDING: { defaultMessage: "Pending..." },
  BINDING_VOLUME: { defaultMessage: "Binding volume..." },
  PREPARING_WORKSPACE: { defaultMessage: "Preparing workspace..." },
  SCHEDULING_POD: { defaultMessage: "Scheduling pod..." },
  STARTING_POD: { defaultMessage: "Starting pod..." },
  READY: { defaultMessage: "Loading Marimo..." },
});
